import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Kit } from 'src/app/models/kit';
import { CarregandoService } from 'src/app/services/carregando.service';
import { KitService } from 'src/app/services/kit.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-kits-para-excluir-modal',
  templateUrl: './kits-para-excluir-modal.component.html',
  styleUrls: ['./kits-para-excluir-modal.component.scss']
})
export class KitsParaExcluirModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  itens: Kit[] = [];
  selecaoTodos = false;

  constructor(public dialogRef: MatDialogRef<KitsParaExcluirModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private kitService: KitService,
  private carregandoService: CarregandoService, private notificacaoService: NotificacaoService) {
    this.itens = data.kits;
  }

  ngOnInit() {
  }

  voltar() {
    this.dialogRef.close();
  }

  selecionarTodos() {
    this.itens.forEach(p => p.checado = this.selecaoTodos);
  }

  excluirKits() {



    const kitsParaExcluir = this.itens.filter(p => p.checado);

    if (kitsParaExcluir.length > 0) {

      swal({
        title: 'Atenção!!',
        text: 'Deseja realmente excluir os kits selecionados?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {

          this.carregandoService.mostra('excluirKits');

          this.kitService.ExcluirKits(kitsParaExcluir).subscribe(
            () => {
              this.notificacaoService.sucesso('Kits excluídos com sucesso!!!');
              this.carregandoService.esconde('excluirKits');
              this.voltar();
            },
            (erro) => {
              this.carregandoService.esconde('excluirKits');
              this.notificacaoService.erro(erro);
            }
          );
        }
      });



    }
  }



}
